import { useAxios } from "../axiosConfig";

const HolidayApi = () => {
    const axiosConfig = useAxios();

    const getHolidayList = async (pageNo, recordPerPage, from, to, langId) => {
        try {
            const response = await axiosConfig.get(
                `/management/holiday/list`,
                {
                    params: {
                        from,
                        to,
                        pageNo,
                        recordPerPage
                    },
                    headers: {
                        'x-language': langId
                    }
                }
            );
            return response;
        } catch (error) {
            throw error;
        }
    };


    const addHoliday = async (data) => {
        try {
            const response = await axiosConfig.post('/management/holiday',
                data,
            );
            return response;
        } catch (error) {
            throw error;
        }
    }

    const editHoliday = async (data) => {
        try {
            const response = await axiosConfig.post('/management/edit-holiday',
                data,
            );
            return response;
        } catch (error) {
            throw error;
        }
    }

    const deleteHoliday = async (data) => {
        try {
            const response = await axiosConfig.post('/management/delete-holiday', data);
            return response;
        } catch (error) {
            throw error;
        }
    }

    return { getHolidayList, addHoliday, deleteHoliday, editHoliday }
}

export default HolidayApi
